import { ViewChild, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('content') private content;
  errorMessage: string;
  email: string;
  password: string;

  constructor(
    private router: Router,
    public auth: AuthService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  doLogin() {
    this.spinner.show();

    let credentials = {
      email: this.email,
      password: this.password
    };

    this.auth.doLogin(credentials).subscribe(data => {
      this.spinner.hide();
      let token = data['token'];
      localStorage.setItem('token', token);
      this.router.navigate(['cdmx']);
    }, err => {
      this.spinner.hide();
      this.errorMessage = err.error.message;
      this.modalService.open(this.content, { centered: true });
    });
  }

}
